export default __webpack_public_path__ + "static/media/RACMXlogo.e90ba25f.svg";